(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pp-charging-addons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pp-charging-addons')) {
    customElements.define('pp-charging-addons', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.syncAdapter();
        this.addEventListener('click', event => {
          const choice = event.target.closest('[data-extras-value]');
          if (!choice || !this.contains(choice)) return;
          const group = choice.closest('[data-extras-option]');
          group.dataset.value = choice.dataset.extrasValue;
          group.querySelectorAll('[data-extras-value]').forEach(button => {
            button.setAttribute('aria-pressed', String(button === choice));
          });
          this.dispatchEvent(new Event('change', { bubbles: true }));
        });
        this.addEventListener('change', () => {
          this.syncAdapter();
          this.querySelectorAll('[data-extras-variant]').forEach(select => {
            const row = select.closest('.pp-extras__row');
            const choices = [...row.querySelectorAll('[data-extras-option]')];
            const match = [...select.options].find(option => choices.every(choice => option.getAttribute('data-option-' + choice.dataset.optionIndex) === choice.dataset.value));
            const checkbox = row.querySelector('[data-extras-check]');
            if (!match || match.dataset.available !== 'true') {
              checkbox.checked = false;
              checkbox.disabled = true;
              row.querySelector('[data-extras-price]').textContent = this.dataset.unavailable;
              return;
            }
            select.value = match.value;
            checkbox.disabled = false;
            checkbox.dataset.variantId = match.value;
            row.querySelector('[data-extras-price]').textContent = match.dataset.price;
          });
          const button = this.querySelector('[data-extras-add]');
          if (button) button.disabled = !this.querySelector('[data-extras-check]:checked');
        });
        this.querySelector('[data-extras-add]')?.addEventListener('click', () => this.addSelected());
      }
      syncAdapter() {
        const row = this.querySelector('[data-stryker-row]');
        if (!row) return;
        const device = this.querySelector('[data-extras-device]');
        const eligible = device ? device.selectedOptions[0]?.dataset.stryker === 'true' : true;
        row.hidden = !eligible;
        const input = row.querySelector('[data-extras-check]');
        input.disabled = !eligible;
        if (!eligible) input.checked = false;
      }
      getItems(quantity = 1, deviceVariant = '') {
        this.syncAdapter();
        const device = this.querySelector('[data-extras-device]');
        const title = device ? device.selectedOptions[0]?.dataset.title : this.dataset.productTitle;
        const variant = device ? device.value : deviceVariant;
        return [...this.querySelectorAll('[data-extras-check]:checked:not(:disabled)')].map(input => ({
          id: input.dataset.variantId,
          quantity,
          properties: { 'For device': title || '', '_Device variant': String(variant || '') }
        }));
      }
      async addSelected(checkout = false) {
        if (this.busy) return;
        const items = this.getItems();
        if (!items.length) return;
        this.busy = true;
        const button = this.querySelector('[data-extras-add]');
        const original = button.textContent;
        const error = this.querySelector('[data-extras-error]');
        error.hidden = true;
        button.disabled = true;
        button.textContent = this.dataset.adding;
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'cart/add.js', {
            method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items})
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
          window.location.assign(checkout ? root + 'checkout' : this.dataset.cartUrl);
        } catch (e) {
          error.textContent = e.message || this.dataset.error;
          error.hidden = false;
          button.textContent = original;
          button.disabled = false;
          this.busy = false;
        }
      }
    });
    document.addEventListener('submit', event => {
      if (event.submitter?.name !== 'checkout') return;
      let extras;
      if (event.target.id === 'CartDrawer-Form') {
        extras = event.target.closest('cart-drawer')?.querySelector('pp-charging-addons[data-mode="cart"]');
      } else if (event.target.id === 'cart') {
        extras = document.querySelector('#main-cart-footer pp-charging-addons[data-mode="cart"]');
      }
      if (!extras?.querySelector('[data-extras-check]:checked')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      extras.addSelected(true);
    }, true);
  }
  } catch(e) { console.error(e); }
})();

})();
